'use client'

import type { ProductCardFragment } from '@gql-generated/graphql'
import { EquivalentProductsLink } from '../equivalent-products/EquivalentProductsLink.client'
import { ProductAvailabilities } from '../product-availabilities/ProductAvailabilities.client'

export type ProductCardBadgesProps = {
  /** The product displayed */
  product: ProductCardFragment

  isClickAndCollectEnabled: boolean
}

export function ProductCardBadges({
  product,
  isClickAndCollectEnabled,
}: ProductCardBadgesProps): React.ReactElement | null {
  return (
    <>
      {product.isEquivalentProductsLinkVisible && product?.urlKey && (
        <EquivalentProductsLink slug={product.urlKey} />
      )}

      <ProductAvailabilities
        product={product}
        isClickAndCollectEnabled={isClickAndCollectEnabled}
        notificationClassName="mr-0.5"
        shortMode
        isTitleVisible={false}
      />
    </>
  )
}
